export default "__VITE_ASSET__DX6jZ6kx__"